var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionSingleChoice = function SvgQuestionSingleChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.64 9.5-9.3 9.3a1.23 1.23 0 0 1-1.73 0l-4.25-4.25A1.23 1.23 0 1 1 7.1 12.8l3.38 3.38 8.42-8.43a1.23 1.23 0 1 1 1.74 1.74z"
  })));
};
export default SvgQuestionSingleChoice;